<template>
    <div class="app" :class="bSeachShow ? 'app-overflow' : ''">
        <div class="header">
            <div class="left">
                <div class="item" :class="{ 'item-active': item.select }" v-for="(item, index) in objConf.tab"
                    :key="item.code" @click="fastSearch('tab', index)">{{ item.name }}</div>
                <div class="item" @click="toAntMap">冷暖风水</div>
            </div>
            <div class="right">
                <img class="search-icon" src="@/assets/images/household/serch.png" alt="">
                <div class="search-text" @click="bSeachShow = !bSeachShow">搜索案例</div>
            </div>
        </div>
        <!-- 搜索弹框 -->
        <div class="search" v-show="bSeachShow">
            <div class="close-t" @click.stop="bSeachShow = !bSeachShow"></div>
            <div class="search-box">
                <div class="input-box goods-wrap">
                    <label>产品型号</label>
                    <div class="goods-content">
                        <input type="text" placeholder="输入产品型号搜索" @input="inputChange" @focus='focusing' @blur="blue" v-model="proType" placeholder-class="place" />
                        <div class="content" v-show="isShowSelectType">
                            <van-list class="data-content" v-if="arrGoods.length" @load="onLoadType" offset="0" :loading="isLoading" :finished="isFinish" finished-text="没有更多了">
                                <div class="item" v-for="item in arrGoods" @mousedown="selectGoodName(item.goods_name)" :key="item.id">{{item.goods_name}}</div>
                            </van-list>
                            <div class="error" v-else>暂无数据</div>
                        </div>
                    </div>
                </div>
                <div class="input-box">
                    <label>小区名称</label>
                    <input type="text" placeholder="输入小区名称或关键字" v-model="rqname" placeholder-class="place" />
                </div>
                <div class="tag-box">
                    <label>案例类型</label>
                    <div class="list">
                        <template v-if="!allCase">
                            <div class="list-item" :class="{ active: item.select }"
                                @click="setSearchConfKey('topic_type', index)"
                                v-for="(item, index) in objConf.topic_type" :key="index">{{ item.name }}</div>
                        </template>
                        <div class="list-item" :class="{ active: allCase }"
                            @click="selectAllCase('topic_type', 'allCase')">全部案例</div>
                    </div>
                </div>
                <div class="tag-box">
                    <label>产品品类</label>
                    <div class="list">
                        <template v-if="!allCategory">
                            <div class="list-item" :class="{ active: item.select }"
                                @click="setSearchConfKey('cate', index)" v-for="(item, index) in objConf.cate"
                                :key="index">{{ item.name }}</div>
                        </template>
                        <div :class="{ active: allCategory }" class="tag list-item"
                            @click="selectAllCase('cate', 'allCategory')">全部</div>
                    </div>
                </div>
                <div class="footer-btn">
                    <p class="clone" @click="bSeachShow = false">取消</p>
                    <p class="active" @click="sumbit()">确定</p>
                </div>
            </div>
        </div>
        <div class="caselist">
            <ul class="wrap">
                <li v-for="(item, index) in caseList" :key="index">
                    <caseitemv2 :itemInfo='item' @showMore="showMore" :index='index'></caseitemv2>
                </li>
                <div class="dropload-tip" id="loading" v-if="nPeriod">正在加载中...</div>
                <div class="dropload-tip" v-if="!nPeriod">没有更多了</div>
            </ul>
        </div>
        <div class="sidebar">
            <div class="address" @click.stop="isShowAddress = !isShowAddress">
                <img class="address-icon" src="@/assets/images/household/address.png" alt="">
                <div class="address-text">{{ objLocation.city ? objLocation.city : "请选择" }}</div>
            </div>
            <div class="switch">
                <div class="map-switch switch-item" @click.stop="$common.redirect('/case/map/v2/index')">
                    <img class="map-icon" src="@/assets/images/household/map.png" alt="">
                    <div class="map-text">地图<br />模式</div>
                </div>
                <div class="switch-item" @click.stop="isShowPicker = !isShowPicker">
                    <img class="map-icon" src="@/assets/images/household/order.png" alt="">
                    <div class="map-text">排序</div>
                </div>
            </div>
        </div>
        <!-- 排序选择 -->
        <van-popup v-model:show="isShowPicker" round position="bottom">
            <van-picker confirm-button-text='确认' cancel-button-text="取消" :columns="columns" value-key="sortName"
                @confirm="onConfirm" :show-toolbar='true' @cancel="isShowPicker = !isShowPicker" />
        </van-popup>
        <!-- 地址联动 -->
        <van-popup v-model:show="isShowAddress" round position="bottom">
            <van-picker ref="addressRef" confirm-button-text='确认' cancel-button-text="取消" :columns="arrPick"
                value-key="name" @confirm="onAddrress" :show-toolbar='true' @cancel="isShowAddress = !isShowAddress" />
        </van-popup>
        <!-- 三级地址联动 -->
        <van-popup v-model:show="isShowSanjiAddress" round position="bottom">
            <van-picker ref="addressSanjiRef" confirm-button-text='确认' cancel-button-text="取消" :columns="arrSheji"
                value-key="name" @confirm="onSanjiAddrress" :show-toolbar='true'
                @cancel="isShowSanjiAddress = !isShowSanjiAddress" />
        </van-popup>
        <div class="baidu_click">
            <div class="baidu_item green" @click="getClickWindom(1)">
                <img src="@/assets/images/case/home_icon.png" alt="">
                商城咨询
            </div>
            <div class="baidu_item wilith" @click="getClickWindom(2)">
                <img src="@/assets/images/case/kefu_icon.png" alt="">
                免费设计<br />报名
            </div>
        </div>
        <div class="info-all" v-if="isPopup">
            <div class="info-box">
                <div class="popup_top"><img src="@/assets/images/user/popup/popup_top.png" /></div>
                <!-- 姓名 -->
                <div class="name-box">
                    <div class="name-title">姓名：</div>
                    <input class="name-input" v-model="name" placeholder="请输入姓名" />
                </div>
                <!-- 电话 -->
                <div class="name-box">
                    <div class="name-title">电话：</div>
                    <input class="name-input" v-model="phone" placeholder="请输入电话" maxlength="11" type="number" pattern="\d*" />
                </div>
                <div class="address-title">地址:</div>
                <!-- 省市区 -->
                <div class="address-box" @click="isShowSanjiAddress = !isShowSanjiAddress">
                    <div class="province">{{ popupProvince }}{{ popupProvince ? '' : '省' }}</div>
                    <div class="province">{{ popupCity }}{{ popupCity ? '' : '市' }}</div>
                    <div class="province">{{ popupDistrict }}{{ popupDistrict ? '' : '区' }}</div>
                </div>
                <!-- 详细地址 -->
                <div class="address-detail">
                    <input class="address-input" v-model="popurAddress" placeholder="请输入您的详细地址" />
                </div>
                <div class="category-box">
                    <div class="category">品类</div>
                    <div class="category-tips">（品类可多选）</div>
                </div>
                <div class="button-box">
                    <div :class="item.state == 0 ? 'cate-button' : 'cate-button-item'"
                        v-for="(item, index) in arrPuporCategory" @click="changeCate(item)">
                        <div>{{ item.title }}</div>
                    </div>
                </div>
                <div class="signUp" @click="getPush">
                    立即报名
                </div>
            </div>
            <div class="close-icon" @click="isPopup = !isPopup">
                <img class="close-icon-image" src="@/assets/images/user/popup/close_icon.png" />
            </div>
        </div>
        <div id="map-container"></div>
        <!-- 通过 iframe 嵌入前端定位组件 -->
        <iframe width="0" height="0" frameborder=0 id="nPageIframe" scrolling="no" src=""></iframe>
    </div>
</template>

<script>
import { requestAesPost5 } from "@/libsV2/requestAes.js";
import caseitemv2 from "@/components/caseitemv2/index";
import { geolocation } from '@/libsV2/geolocation.js'
import path from "path";
export default {
    name: 'lists',
    components: {
        caseitemv2
    },
    data() {
        return {
            isPopup: false,
            name: '',
            phone: '',
            popurAddress: '',
            isShowPicker: false,
            bSeachShow: false,
            objConf: {
                brand: [],
                cate: [],
                catess: [],
                goods_type: [],
                house_area: [],
                tab: [],
                topic_type: [],
            },
            columns: [
                { sortName: '收藏量由高到低', value: 'collect_num' },
                { sortName: '转发量由高到低', value: 'shares' },
                { sortName: '发布时间顺序', value: 'time_asc' },
                { sortName: '发布时间倒序', value: 'time_desc' },
            ],
            sort: {
                time_desc: 0,
                time_asc: 0,
                shares: 0,
                collect_num: 0,
            },
            rqname: '',
            nPage: 0,
            allCategory: false,//是否选择了全部品类
            allCase: false,//是否选择了全部案例
            objLocation: {
                cityId: '',
                provinceId: '',
            },
            caseList: [],
            isLoading: true,
            nPeriod: true,
            arrPick: [],
            isShowAddress: false,
            isShowSanjiAddress: false,
            arrSheji: [],
            popupCity: '',
            popupProvince: '',
            popupDistrict: '',
            arrPuporCategory: [
                {
                    id: 1,
                    title: '热水器',
                    state: 0
                },
                {
                    id: 2,
                    title: '烟机',
                    state: 0
                },
                {
                    id: 3,
                    title: '净水机',
                    state: 0
                },
                {
                    id: 4,
                    title: '冷暖风水',
                    state: 0
                },
                {
                    id: 5,
                    title: '其它',
                    state: 0
                },
            ],
            proType:"",
            proTypePage:0,
            arrGoods:[],
            isFinish:false,//是否加载完产品所有数据
            isShowSelectType: false, //是否展示产品型号选择框
        }
    },
    created() {
        let _that = this;
        _that.$store.commit("loadSwitch", true);
        _that.$router.push({path:'/case/map/v2/lists',query:{ald_source:_that.$route.query.ald_source,track_action:'share_vertical_media',track_id:_that.$route.query.ald_source || 'h5',track_uuid:sessionStorage.getItem('page_uuid')}}) 
        Promise.all([_that.getConf(), _that.getAddress()]).then(res => {
            if (!_that.$storage.getStorage('objLocation')) {
                geolocation().then(geolocation=>{
                    _that.$storage.setStorage('objLocation', geolocation.result);
                    _that.objLocation = Object.assign(_that.objLocation, geolocation.result);
                    _that.getCityIdByName(geolocation.result).then(res => {
                        _that.getGoods();
                        _that.seachFormData().then(res => {
                            _that.caseLists(res)
                        });
                    });
                }).catch(err=>{
                    document.getElementById('nPageIframe').src = 'https://aotest2.iwxapi.com/getLocation/location5.html';
                    window.addEventListener('message', (event) => {
                        //接收位置信息
                        var loc = event.data;
                        if (loc.module == 'selfpositioning' || loc.module == 'clickpositioning') {
                            const { qqmap } = loc;
                            _that.$storage.setStorage('objLocation', qqmap);
                            _that.objLocation = Object.assign(_that.objLocation, qqmap);
                            document.getElementById('nPageIframe').width = '0';
                            document.getElementById('nPageIframe').height = '0';
                            _that.getCityIdByName(qqmap).then(res => {
                                _that.getGoods();
                                _that.seachFormData().then(res => {
                                    _that.caseLists(res)
                                });
                            });
                        } else if (loc.module == 'lose') {
                            _that.$store.commit("loadSwitch", false);
                            document.getElementById('nPageIframe').width = '100%';
                            document.getElementById('nPageIframe').height = '100%';
                        }
                    }, false);
                })
                // location.initMap('map-container').then(geolocation=>{
                //     if(geolocation.status == "complete"){
                //         _that.$storage.setStorage('objLocation', geolocation.result);
                //         _that.objLocation = Object.assign(_that.objLocation, geolocation.result);
                //         _that.getCityIdByName(geolocation.result).then(res => {
                //             _that.getGoods();
                //             _that.seachFormData().then(res => {
                //                 _that.caseLists(res)
                //             });
                //         });
                //     }else{
                //         document.getElementById('nPageIframe').src = 'https://aotest2.iwxapi.com/getLocation/location5.html';
                //         window.addEventListener('message', (event) => {
                //             //接收位置信息
                //             var loc = event.data;
                //             if (loc.module == 'selfpositioning' || loc.module == 'clickpositioning') {
                //                 const { qqmap } = loc;
                //                 _that.$storage.setStorage('objLocation', qqmap);
                //                 _that.objLocation = Object.assign(_that.objLocation, qqmap);
                //                 document.getElementById('nPageIframe').width = '0';
                //                 document.getElementById('nPageIframe').height = '0';
                //                 _that.getCityIdByName(qqmap).then(res => {
                //                     _that.getGoods();
                //                     _that.seachFormData().then(res => {
                //                         _that.caseLists(res)
                //                     });
                //                 });
                //             } else if (loc.module == 'lose') {
                //                 _that.$store.commit("loadSwitch", false);
                //                 document.getElementById('nPageIframe').width = '100%';
                //                 document.getElementById('nPageIframe').height = '100%';
                //             }
                //         }, false);
                //     }
                // })
            } else {
                _that.objLocation = Object.assign(_that.$storage.getStorage('objLocation'));
                _that.getCityIdByName(_that.$storage.getStorage('objLocation')).then(res => {
                    _that.getGoods();
                    _that.seachFormData().then(res => {
                        _that.caseLists(res)
                    });
                });
            }
        })
    },
    methods: {
        // 监听产品型号input输入
        inputChange() {
            this.isFinish = false;
            this.proTypePage = 0;
            this.arrGoods = [];
            this.getGoods();
        },
        // 产品型号input框聚焦
        focusing() {
            this.isShowSelectType = true;
        },
        blue() {
            this.isShowSelectType = false;
        },
        // 选择产品型号
        selectGoodName(name) {
            this.proType = name;
        },
        // 上拉加载更多
        onLoadType() {
            if (this.arrGoods.length >= 20) {
                this.proTypePage++;
                this.getGoods();
            }
        },
        // 获取产品型号
        getGoods() {
            this.isLoading = true;
            requestAesPost5("topic/aes/searchGoods", {
                word: this.proType ? this.proType : "",
                page: this.proTypePage,
                limit: 20,
            }).then((res) => {
                this.isLoading = false;
                if (res.data.error == 0) {
                    if (
                        this.proTypePage != 0 &&
                        res.data.data.result.length < 20
                    ) {
                        this.isFinish = true;
                        return false;
                    }
                    let arr = this.arrGoods.concat(res.data.data.result);
                    this.arrGoods = arr;
                }
            });
        },
        // 创建观察者
        intersection() {
            let _that = this;
            let loading = document.getElementById('loading');
            // 建立观察者
            let ob = new IntersectionObserver(
                function (entries) {
                    let entry = entries[0];
                    if (entry.isIntersecting && !_that.isLoading && _that.nPeriod) {
                        _that.nPage++;
                        _that.seachFormData().then(res => {
                            _that.caseLists(res)
                        });
                    }
                },
                {
                    thresholds: 0.1,
                }
            );
            // 观察
            ob.observe(loading)
        },
        // 三级联动
        getAddress() {
            return new Promise((resolve, reject) => {
                let _that = this;
                _that.$http.get("https://pro-core.babycdn.com/2021/aosmith/lottery/china.json").then((res) => {
                    let arrAddress = res.body.data.result;
                    let arrPick = JSON.parse(JSON.stringify(arrAddress[0]));
                    let arrSheji = JSON.parse(JSON.stringify(arrAddress[0])).slice(1);
                    arrPick.forEach(it => {
                        if (it.id != 0) {
                            it.children = arrAddress[it.id];
                        } else if (it.id == 0) {
                            it.children = [{ name: '全国', id: 0 }];
                        }
                    })
                    // 三级联动数据
                    arrSheji.forEach(it => {
                        if (it.id != 0) {
                            it.children = arrAddress[it.id];
                            it.children.forEach(is => {
                                is.children = arrAddress[is.id];
                            })
                        }
                    })
                    _that.arrSheji = arrSheji;
                    _that.arrPick = arrPick;
                    resolve(res)
                })
            })
        },
        // 选择选择城市
        onAddrress(e) {
            let _that = this;
            let arr = this.$refs.addressRef.getIndexes();
            _that.objLocation.provinceId = _that.arrPick[arr[0]].id;
            _that.objLocation.cityId = _that.arrPick[arr[0]].children[arr[1]].id;
            _that.objLocation.city = e[1];
            _that.nPage = 0;
            _that.caseList = [];
            _that.isShowAddress = !_that.isShowAddress;
            _that.seachFormData().then(res => {
                _that.caseLists(res)
            });
        },
        // 三级联动选择城市
        onSanjiAddrress(e) {
            let _that = this;
            _that.popupCity = e[0];
            _that.popupProvince = e[1];
            _that.popupDistrict = e[2];
            _that.isShowSanjiAddress = !_that.isShowSanjiAddress;
        },
        // 获取城市id
        getCityIdByName(data = {}) {
            return new Promise((resolve) => {
                let _that = this;
                requestAesPost5('tool/aes/index', {
                    cityName: data.city,
                    provinceName: data.province,
                }).then((res) => {
                    _that.objLocation.cityId = res.data.data.result.city;
                    _that.objLocation.provinceId = res.data.data.result.province;
                    resolve()
                });
            });
        },
        // 获取搜索配置
        getConf() {
            return new Promise((resolve, reject) => {
                let _that = this;
                requestAesPost5('topic/aes/getConf').then(res => {
                    let objConf = res.data.data.result;
                    for (let key in objConf) {
                        for (let i = 0; i < objConf[key].length; i++) {
                            objConf[key][i].select = false;
                        }
                    }
                    _that.objConf = objConf
                    resolve(objConf)
                })
            })
        },
        // 点击顶部获取列表数据（单选）
        fastSearch(key, num) {
            let _that = this;
            _that.objConf[key].forEach((it, index) => {
                if (index == num) {
                    it.select = !it.select;
                } else {
                    it.select = false;
                }
            })
            _that.nPage = 0;
            _that.caseList = [];
            _that.seachFormData().then(res => {
                _that.caseLists(res)
            });
        },
        // 搜搜获取列表数据（多选）
        setSearchConfKey(key, num) {
            let _that = this;
            _that.objConf[key].forEach((it, index) => {
                if (index == num) {
                    it.select = !it.select;
                }
            })
        },
        // 全部案例
        selectAllCase(key, bKey) {
            let _that = this;
            let nLength = 0;
            _that.objConf[key].forEach((it, index) => {
                if (_that[bKey]) {
                    it.select = false;
                } else {
                    it.select = true;
                }
                nLength++;
                if (nLength == _that.objConf[key].length) {
                    _that[bKey] = !_that[bKey];
                }
            })
        },
        // 搜索列表
        sumbit() {
            let _that = this;
            _that.nPage = 0;
            _that.caseList = [];
            _that.seachFormData().then(res => {
                _that.caseLists(res)
                _that.bSeachShow = !_that.bSeachShow;
            });
        },
        // 参数集合
        seachFormData() {
            return new Promise((resolve, reject) => {
                //  产品品类
                let parent_id = this.objConf.cate.map((it) => {
                    if (it.select) {
                        return it.code;
                    }
                }).filter(l => l != undefined).join(',');
                // 案例类型
                let topicType = this.objConf.topic_type.map((it) => {
                    if (it.select) {
                        return it.code;
                    }
                }).filter(l => l != undefined).join(',');
                // 头部搜索
                let subparent_id = this.objConf.tab.map((it) => {
                    if (it.select) {
                        return it.code;
                    }
                }).filter(l => l != undefined).join(',');
                let data = {
                    source: "xcx",
                    search_keys: this.rqname,
                    page: this.nPage,
                    city_id: this.objLocation.cityId,
                    province_id: this.objLocation.provinceId,
                    limit: 10,
                    parent_id: parent_id,
                    type: topicType,
                    model: this.proType,
                    subparent_id: subparent_id,
                    order: JSON.stringify(this.sort),
                }
                resolve(data)
            })
        },
        // 案例列表
        caseLists(data = {}) {
            let _that = this;
            _that.isLoading = true;
            _that.nPeriod = true;
            _that.$store.commit("loadSwitch", true);
            requestAesPost5("topic/aes/lists", data).then((res) => {
                _that.isLoading = false;
                if (res.data.error == 0) {
                    let arrCaselist = res.data.data.result.list;
                    arrCaselist.forEach((item) => {
                        item.imgArr = [];
                        item.videoArr = [];
                        item.arrCategory = [];
                        if (item.scence.length) {
                            item.scence.forEach((it) => {
                                if (it.mp4_info) {
                                    if (it.mp4_info.mp4_url) {
                                        item.videoArr.push(it.mp4_info);
                                    }
                                }
                            });
                            item.scence.forEach((it) => {
                                if (item.imgArr.length < 9) {
                                    if (it.house_img.length) {
                                        item.imgArr.push(it.house_img[0]);
                                    }
                                }
                            });
                        }

                        if (item.imgArr.length < 9) {
                            item.scence.forEach((it) => {
                                if (it.house_img.length) {
                                    it.house_img.forEach((itx, index) => {
                                        if (index > 0) {
                                            item.imgArr.push(itx);
                                        }
                                    });
                                }
                            });
                        }
                        item.scence.forEach((it) => {
                            if (it.device_info.length) {
                                it.device_info.forEach((itx, index) => {
                                    item.arrCategory.push(itx);
                                });
                            }
                        });
                        for (let i = 0; i < item.arrCategory.length; i++) {
                            for (let j = i + 1; j < item.arrCategory.length;) {
                                if (
                                    item.arrCategory[i].id ===
                                    item.arrCategory[j].id
                                ) {
                                    //通过属性进行匹配；
                                    item.arrCategory.splice(j, 1); //去除重复的对象；
                                } else {
                                    j++;
                                }
                            }
                        }
                    });
                    _that.caseList = _that.caseList.concat(arrCaselist);
                    _that.$store.commit("loadSwitch", false);
                    if (_that.nPage == res.data.data.result.page - 1 || res.data.data.result.page == 0) {
                        _that.nPeriod = false;
                        return false
                    }
                } else {
                    _that.$store.commit("loadSwitch", false);
                    _that.nPeriod = false;
                    _that.$toast({
                        message: res.data.msg,
                        duration: 1200,
                    });
                }
            })
        },
        toAntMap() {

        },
        // 点击进入详情
        showMore(e) {
            this.$router.push({path:"/case/map/v2/details", query:{ ald_source:this.$route.query.ald_source || '',topicid: e.id,track_action:'share_vertical_media',track_id:this.$route.query.ald_source || 'h5',track_uuid:sessionStorage.getItem('page_uuid')}});
        },
        // 百度统计跳转链接
        getClickWindom(type) {
            switch (type) {
                case 1:
                    let source = 'shop_h5list';
                    if(this.$route.query.ald_source){
                        source = 'shop_'+ this.$route.query.ald_source;
                    }
                    this.$common.pushEvent('click_vertical_media', this.$route.query.ald_source || 'h5');
                    _hmt.push(['_trackEvent', source, source, source]);
                    window.location.href =
                        'https://shop.m.jd.com/?shopId=1000001098'
                    break;
                case 2:
                    this.isPopup = true
                    break;
            }
        },
        onConfirm(e) {
            let _that = this;
            for (let key in _that.sort) {
                if (e.value == key) {
                    _that.sort[key] = 1;
                } else {
                    _that.sort[key] = 0;
                }
            }
            _that.nPage = 0;
            _that.caseList = [];
            _that.isShowPicker = !_that.isShowPicker;
            _that.seachFormData().then(res => {
                _that.caseLists(res)
            });
        },
        //立即报名，数据上传接口
        getPush() {
            if (this.name == '') {
                this.$toast("请输入姓名", {
                    duration: 1500,
                });
                return
            }
            if (this.phone == '') {
                this.$toast("请输入电话", {
                    duration: 1500,
                });
                return
            }
            if (!/^1[3|4|5|8|6|9|][0-9]\d{8}$/.test(this.phone)) {
                this.$toast("请输入正确电话", {
                    duration: 1500,
                });
                return
            }
            if (this.popupProvince == '' || this.popupCity == '' || this.popupDistrict == '') {
                this.$toast("请选择省市区", {
                    duration: 1500,
                });
                return
            }
            let arrType = this.arrPuporCategory.map(it=>{
                if(it.state == 1){
                    return it.title;
                }
            }).filter(l => l != undefined).join(',');
            if (arrType == '') {
                this.$toast("请选择品类", {
                    duration: 1500,
                });
                return
            }
            requestAesPost5("topic/free/push", {
                name: this.name,
                phone: this.phone,
                province: this.popupProvince,
                city: this.popupCity,
                district: this.popupDistrict,
                address: this.popurAddress,
                type: arrType,
                resource: this.$route.query.ald_source || '',
            }).then((res) => {
                this.$toast({
                    message: res.data.data.result,
                    duration: 1200,
                });
                this.isPopup = false
            })
        },
        changeCate(item){
            item.state = item.state ? 0 : 1
        }
    }
}
</script>

<style lang='scss' scoped>
#nPageIframe {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
}

@import './lists.scss';
</style>